import { render, staticRenderFns } from "./ButtonCreateAccount.vue?vue&type=template&id=71cdee24&"
import script from "./ButtonCreateAccount.vue?vue&type=script&lang=js&"
export * from "./ButtonCreateAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports